import React, { useCallback } from 'react';

import { api } from '../../../../helpers/client';
import type { IUnitCodeSuggest } from '../../../../services/passport/types';
import { ISuggestProps } from './types';
import { SuggestAsync } from '.';

export type { IUnitCodeSuggest };

type IUnitCodeSuggestProps<T> = Pick<ISuggestProps<T>, 'input' | 'onChange' | 'onBlur' | 'onFocus' | 'onSelect'>;

export const UnitCodeSuggest = (props: IUnitCodeSuggestProps<IUnitCodeSuggest>) => {
    const getOptions = useCallback((value) => {
        const code = value.replace(/\D/g, '');

        return code ? api.unitCodeSuggest(code) : Promise.resolve([]);
    }, []);

    const filterOptions = (options: Array<IUnitCodeSuggest>) => {
        const mappedOptions = new Map(options.map((item) => [item.code, item]));
        return Array.from(mappedOptions.values());
    };

    return (
        <SuggestAsync<IUnitCodeSuggest>
            {...props}
            getOptions={getOptions}
            filterOptions={filterOptions}
            mapperOption={(option) => ({ name: option.name, value: option.code, option })}
        />
    );
};
